const eventDebugger = {

    events: [],
    addEvent(ev) {

        this.events.push(ev);
        if (this.events.length > CWCONFIG.debug.eventStackSize) {

            this.events = this.events.slice(-CWCONFIG.debug.eventStackSize);

        }

    },

    getEvents() {

        return this.events;

    },

};

export default eventDebugger;



// WEBPACK FOOTER //
// ./scripts/common/services/-RFC.eventDebugger.js